/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
export const getAvailableSheetsCount = (licenseInfo = {}) => {
	const { maxStreamsheets = -1, usedStreamsheets = 0 } = licenseInfo;
	return maxStreamsheets < 0 ? maxStreamsheets : Math.max(0, maxStreamsheets - usedStreamsheets);
};

export const areSheetsAvailable = (licenseInfo = {}) => {
	const available = getAvailableSheetsCount(licenseInfo);
	return available < 0 || available > 0;
};
